import React from "react"

import "./header-legal.scss"

const HeaderLegal = ({ colorBanner, title }) => {
  return (
    <div
      className={
        "f-header-legal " + (colorBanner === "Cian" ? "cian" : "purple")
      }
    >
      <div className="f-title-legal-container">
        <h1 className="f-title-legal">{title}</h1>
      </div>
    </div>
  )
}

export default HeaderLegal
